import { render, staticRenderFns } from "./createRecruitmentCollectionH5.vue?vue&type=template&id=2664a40b&scoped=true"
import script from "./createRecruitmentCollectionH5.vue?vue&type=script&lang=js"
export * from "./createRecruitmentCollectionH5.vue?vue&type=script&lang=js"
import style0 from "./createRecruitmentCollectionH5.vue?vue&type=style&index=0&id=2664a40b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2664a40b",
  null
  
)

export default component.exports